import { Headline, Paragraph, Link } from 'View/Common';
import { Image } from 'View/Common';
import { freddySad } from 'img/closing_popup';
import Style from './ClosingBanner.styles';

const MAIL = 'info@7schlaefer.app';

export const ClosingBanner = () => {
  return (
    <Style className="closing-banner">
      <div className="inner">
        <div className="illu-wrapper">
          <Image src={freddySad} alt="Trauriger Siebenschläfer" className="freddy" />
        </div>
        <div className="text-wrapper">
          <Headline level={2}>7Schläfer wird am 30.09.2026 eingestellt</Headline>
          <Paragraph>
            Bei Fragen dazu wende dich an{' '}
            <Link href={`mailto:${MAIL}`} title={`E-Mail senden an ${MAIL}`}>
              {MAIL}
            </Link>
          </Paragraph>
        </div>
      </div>
    </Style>
  );
};
